import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id = 0,
    name = '',
    desc = '',
    isDef = 0,
    config = {
        levels: 0,
        nodes: [],
    },
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.auditFlowCfg.myOrgSaveCfg, {
        id,
        name,
        desc,
        isDef,
        config,
    }, options);
    if (error) return { error, status };
    return content || {};
};
